import * as React from "react";
import { forwardRef } from "react";
const SvgPlay = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { transform: "translate(0 -1)" }, /* @__PURE__ */ React.createElement("path", { d: "M4 3.72318C4 2.95536 4.82948 2.47399 5.49614 2.85494L16.4806 9.13176C17.1524 9.51565 17.1524 10.4843 16.4806 10.8682L5.49614 17.1451C4.82948 17.526 4 17.0446 4 16.2768V3.72318Z", fill: "currentColor" })));
const ForwardRef = forwardRef(SvgPlay);
export default ForwardRef;
